<template>
  <div style="background: #FAF9F5;">
    <!-- Pricing Table Starts -->

    <section class="pricing-table section-padding picBox">
      <div class="campusTit" ref="campusTit">
        <div class="campusTit-top">
          <div @click="swiperChange('1')" class="campusTit-top-text" ref="Campus">CAMPUS SCENERY</div>
          <div @click="swiperChange('2')" class="campusTit-top-text" ref="International">STUDENT DEMEANOR</div>
          <div class="campusTit-bot" :style="{left: left + 'px'}"></div>
        </div>

      </div>

      <div class="container " >
        <div class="pricing-table-Box" style="width: 100%;">
          <!--          <pic-fall :items="pictureList" :column-width="200" :gutter="100" />-->
          <gallery :bigImg="bigImg" v-if="bigImg.length" />
        </div>
      </div>


    </section>
    <!-- Pricing Table End -->

  </div>
</template>

<script>
  import picFall from '@/component/picFall.vue'
  import gallery from '@/component/Gallery.vue'
  export default {
    components: {
      picFall,
      gallery
    },
    data () {
      return {
        active: '1',
        left: 40,
        bigImg: [],
        pictureList: [

          {
            id: 1234,
            // title: 'Suzhou Campus held "Taste Buds Roaming" world food theme catering activities to enhance cultural exchanges and friendship between Chinese and foreign youth',
            src: 'http://en.sc.ruc.edu.cn/static/images/Gallery/4.JPG',
            alt: 'Suzhou Campus held "Taste Buds Roaming" world food theme catering activities to enhance cultural exchanges and friendship between Chinese and foreign youth'
          },
          {
            id: 123456,
            // title: 'Far-sighted youth visit Zhouzhuang ancient Town to experience the long history of Chinese civilization',
            src: 'http://en.sc.ruc.edu.cn/static/images/Gallery/6.png',
            alt: 'Far-sighted youth visit Zhouzhuang ancient Town to experience the long history of Chinese civilization'
          },
          {
            id: 1234567,
            // title: 'Chinese and foreign student representatives of Foresight Academy went to Yan \'an to carry out the first class of enrollment',
            src: 'http://en.sc.ruc.edu.cn/static/images/Gallery/7.jpg',
            alt: 'Chinese and foreign student representatives of Foresight Academy went to Yan an to carry out the first class of enrollment'
          },
          {
            id: 12345678,
            // title: '',
            src: 'http://en.sc.ruc.edu.cn/static/images/Gallery/9.jpg',
            alt: ''
          }
        ],
        CampusList: [
          {
            id: 1,
            src: 'http://en.sc.ruc.edu.cn/static/images/Gallery/10.jpg',
            alt: ''
          },
          {
            id: 2,
            src: 'http://en.sc.ruc.edu.cn/static/images/Gallery/11.jpg'
          },
          {
            id: 3,
            src: 'http://en.sc.ruc.edu.cn/static/images/Gallery/12.jpg'
          }, {
            id: 4,
            src: 'http://en.sc.ruc.edu.cn/static/images/Gallery/13.jpg'
          }, {
            id: 5,
            src: 'http://en.sc.ruc.edu.cn/static/images/Gallery/14.jpg'
          },
          {
            id: 6,
            src: 'http://en.sc.ruc.edu.cn/static/images/Gallery/15.jpg'
          }, {
            id: 7,
            src: 'http://en.sc.ruc.edu.cn/static/images/Gallery/16.jpg'
          }
        ]
      }
    },
    mounted () {
      this.bigImg = this.CampusList
      this.swiperChange('1')
    },
    methods: {
      swiperChange (index) {
        if (this.active === index) return
        this.active = index
        if (index === '1') {
          this.bigImg = this.CampusList
          let widthleft = this.$refs.Campus.clientWidth / 2 - 25
          this.left = widthleft
        } else {
          this.bigImg = this.pictureList
          let widthleft = this.$refs.campusTit.clientWidth - this.$refs.International.clientWidth / 2 - 25
          this.left = widthleft
        }
      }
    }
  }
</script>

<style scoped lang="scss">
    .pricing-table-Box{
      margin-top: 30px;
    }
    .campusTit{
        width: 400px;
        margin: 50px auto 50px auto;
      .campusTit-top{
        position: relative;
        height: fit-content;
          display: flex;
          align-items: center;
         justify-content: space-between;
            .campusTit-top-text{
              font-family: PingFang SC;
              font-weight: bold;
              font-size: 16px;
              color: #8E3637;
              line-height: 36px;
              cursor: pointer;
            }
      }
      .campusTit-top:before{
        content: ' ';
        position: absolute;
        bottom: -20px;
        left: -15px;
        width: 430px;
        height: 2px;
        background: #D6D6D6;
      }

      .campusTit-bot{
        position: absolute;
        bottom: -20px;
        width: 50px;
        height: 3px;
        background: #D00202;
        -webkit-transition: all .3s;
        transition: all .3s;
      }
      //.activeLf:after{
      //  content: ' ';
      //
      //
      //}
      //.activeRt:after{
      //  content: ' ';
      //  position: absolute;
      //  bottom: -20px;
      //  width: 50px;
      //  height: 3px;
      //  background: #D00202;
      //  left: 270px;
      //  -webkit-transition: all .3s;
      //  transition: all .3s;
      //
      //}

    }

    @media (max-width: 575.98px) {
      .picBox{
        padding: 20px 0 !important;
      }
      .campusTit{
        width: 60%;
        margin: 30px auto ;
        .campusTit-top{
          position: relative;
          height: fit-content;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .campusTit-top-text{
            font-family: PingFang SC;
            font-weight: bold;
            font-size: 10px;
            color: #8E3637;
            line-height: 24px;
            cursor: pointer;
          }
        }
        .campusTit-top:before{
          content: ' ';
          position: absolute;
          bottom: -20px;
          left: -5%;
          width: 110%;
          height: 2px;
          background: #D6D6D6;
        }

        .campusTit-bot{
          position: absolute;
          bottom: -20px;
          width: 50px;
          height: 3px;
          background: #D00202;
          -webkit-transition: all .3s;
          transition: all .3s;
        }


      }
    }

</style>



// WEBPACK FOOTER //
// PricingPlan.vue?21fc39cb